import {useTranslation} from "react-i18next";
import {productMenuImages, products} from "../data/data";
import {Link} from "react-router-dom";
import {useState} from "react";

function ProductMenu(props) {
    const {t} = useTranslation();
    const [displayImage, setDisplayImage] = useState()

    const onHover = (key) => {
        let image = productMenuImages[key];
        console.log(image);
        setDisplayImage(image);
    }

    const onLeave = () => {
        setDisplayImage(null)
    }

    const navigateToTop = () => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }

    return (
        <div className="absolute top-24 left-0 bg-white min-w-full p-8 max-xl:p-4 flex justify-center max-md:hidden"
             onMouseLeave={props.onMouseLeave}>
            <div className="max-w-screen-xl flex flex-row">
                <div className="flex flex-col w-2/3">
                    <div className="text-xl font-bold text-left mb-4">{t("menu_product_content_title")}</div>
                    <div className="flex flex-wrap justify-center" onMouseLeave={onLeave}>
                        {products.map((product) => (
                            <div key={product.id} className="min-w-64 mr-16 max-xl:mr-4">
                                <div className="text-sm font-bold text-left pb-2 border-b-[1px] border-black">
                                    <Link to={`/product/${product.type}`}>{t(product.category)}</Link>
                                </div>
                                {product.groups.map((group, index) => (
                                    <div key={index} className={`flex flex-col space-y-1 text-secondary-color py-4 
                                    ${index > 0 ? "pt-2" : ""}`}>
                                        <p className="text-sm text-black text-start py-1">{t(group.name)}</p>
                                        {group.items.map((item, index) => (
                                            <div key={index} onMouseOver={() => onHover(`${product.type}_${item.id}`)}>
                                                <Link to={`/product/${product.type}/${item.id}`}
                                                      onClick={() => navigateToTop()}
                                                      className={`flex items-center hover:bg-green p-2 gap-3 text-black`}>
                                                    <img src={item.icon} className="w-5 aspect-square object-contain"
                                                         alt=""/>
                                                    <span className="text-sm">{t(item.title)}</span>
                                                </Link>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="w-96">
                    {displayImage && <img src={displayImage} alt={`${displayImage}`}
                                          className="visible max-lg:hidden my-12 ml-8
                                object-cover rounded-2xl overflow-hidden"/>}
                </div>
            </div>
        </div>
    )
}

export default ProductMenu;